import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

// Interface for dialog props
interface ConfirmationDialogProps {
  confirmOpen: boolean; // Flag to control dialog visibility (corrected prop name)
  title: string; // Title text for the dialog
  message: string; // Confirmation message displayed inside the dialog
  onClose: (confirmed: boolean) => void; // Callback function for handling OK/Cancel actions
}

export default function ConfirmationDialog(props: ConfirmationDialogProps) {
  const { confirmOpen, title, message, onClose } = props;

  const handleConfirmClose = (confirmed: boolean) => {
    onClose(confirmed);
  };

  return (
    <Dialog open={confirmOpen} onClose={() => handleConfirmClose(false)}>  {/* Use 'open' prop */}
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={() => handleConfirmClose(false)}>Cancel</Button>
        <Button variant="contained" color="primary" onClick={() => handleConfirmClose(true)}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}
